import {Dispatch, SetStateAction} from 'react';
import CustomRadio from '../../../../components/mazraeKit/customRadio';
import {
  CashBackStatus,
  ICashBackCard,
} from '../../../lendtech/cashBack/api/getCashBackCards/cashBackCards.types';
import {MyCreditsTabsType} from '../MyCreditsPage';
import {
  getCurrentCashBackBadge,
  getPaidCashBackBadge,
} from '../helper/getCashBackBadge';
import ValueInfo from './ValueInfo';
import {calculateCashBackActiveCredit} from '../../../lendtech/cashBack/helpers/cashBackAmountAmountHelpers';

interface IProps {
  cashback: ICashBackCard;
  isSelected: boolean;
  setSelectedLoanGuid: Dispatch<SetStateAction<string>>;
  tabType?: MyCreditsTabsType;
}

const CashBackCard = ({
  cashback,
  isSelected,
  setSelectedLoanGuid,
  tabType,
}: IProps) => {
  const {guid, status, amount, used_amount, reserved_amount} = cashback;

  const isTabPaid = tabType === 'paid';

  const isCashBackPaid =
    status === CashBackStatus.Paid || status === CashBackStatus.Consumed;

  const toggleLoanCard = () => {
    if (isTabPaid) return;

    setSelectedLoanGuid(prev => (prev === guid ? '' : guid));
  };

  const activeCreditValue = calculateCashBackActiveCredit(
    status,
    amount,
    used_amount,
    reserved_amount,
  )?.toLocaleString();

  return (
    <div
      className="flex min-h-[120px] items-start gap-2 p-3 border-[1px] rounded-2xl border-gray-100 bg-gray-50"
      onClick={toggleLoanCard}
      id={cashback.guid}
    >
      {!isTabPaid && (
        <CustomRadio
          title=""
          inputClassname="size-4 mt-0.5"
          value={guid}
          checked={isSelected}
          onChange={toggleLoanCard}
          onClick={e => e.stopPropagation()}
          name="cashback"
        />
      )}

      <div className="flex flex-col w-full gap-1.5">
        <div className="flex gap-2 mt-0.5">
          <i className="text-lg text-gray-800 icon-nameWallet-income" />
          <span className="text-sm font-medium text-gray-900">
            اعتبار بازگشتی
          </span>
          {!isCashBackPaid && getCurrentCashBackBadge(status)}
        </div>

        <div className="flex flex-col gap-1 mt-1">
          <ValueInfo
            title="کل اعتبار"
            value={amount.toLocaleString()}
            valueUnit="تومان"
          />

          {!isCashBackPaid && (
            <ValueInfo
              title="اعتبار فعال"
              value={activeCreditValue}
              valueUnit="تومان"
            />
          )}

          {isCashBackPaid && getPaidCashBackBadge(status)}
        </div>
      </div>
    </div>
  );
};

export default CashBackCard;
